module.exports = __webpack_public_path__ + "media/images/icon-dashboard-6a05eae3f337cea85a8a4335a973f3c7.png";